import { createNamespace } from './base'

const send = createNamespace( '/api/clinic' )

const ClinicApi = {
    ClinicGetById: ({ id, lang = 'ru' }) => send({ action: 'get-by-id', data: { id, lang } })
}

export default ClinicApi